<template>
  <div>
    <list
      ref="list"
      unit="销售单据汇总表"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.summaryList"
      @reset-query="$emit('reset-select')"
      isSumData
      show-summary  
      :summary-method="getSummaries"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input
            size="mini"
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="客户名称">
          <customer @restaurants="setSupplier" :state="params.CustomerName" />
        </el-form-item>
        <el-form-item label="来源">
          <el-select
            size="mini"
            v-model="params.Source"
            placeholder="请选择"
            clearable
          >
            <el-option label="自主下单" :value="0"></el-option>
            <el-option label="代客下单" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select
            size="mini"
            v-model="params.PayType"
            placeholder="请选择"
            clearable
          >
            <el-option label="余额支付" :value="1"></el-option>
            <el-option label="信用支付" :value="2"></el-option>
            <el-option label="微信支付" :value="3"></el-option>
            <el-option label="线下支付" :value="4"></el-option>
            <el-option label="其它" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据类型">
          <el-select
            size="mini"
            v-model="params.DocType"
            placeholder="请选择"
            clearable
          >
            <el-option label="销货单" :value="1"></el-option>
            <el-option label="销货退货单" :value="2"></el-option>
            <el-option label="商城销售补货单" :value="3"></el-option>
            <el-option label="商城销售退货单" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销状态">
          <el-select
            size="mini"
            v-model="params.PayStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="挂账" :value="1"></el-option>
            <el-option label="已收款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属机构">
              <el-select size="mini" v-model="params.DpId" placeholder="请选择机构">
         
                  <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
           
              </el-select>
            </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
        <el-table-column prop="DocDate" label="单据日期">
          <template slot-scope="{row}">
            {{  row.DocDate.split(" ")[0]}}
          </template>
        </el-table-column>
      <el-table-column prop="DocNo" label="单据编码"/>
        <el-table-column prop="TradeUnitName" label="客户名称"/>
        <el-table-column prop="Amount" label="销货金额"/>
        <el-table-column prop="SourceName" label="来源"/>
      <el-table-column prop="DocType" label="单据类型"/>
        <el-table-column prop="PayType" label="支付方式"/>
        <el-table-column prop="PayStatus" label="核销状态"/>
        <slot name="column"></slot>
      </template>
    </list>
    
  </div>
  
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import customer from "@/components/common/customer/customer";

export default {
  mixins: [listMixin],
  components: { list,customer },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    this.params.DocDateStart = today
    this.params.DocDateEnd = today
  },
  mounted() {
    this.toSearch()
  },
  data() {
    return {
      api: require("@/api/sale/sales").default,
      dpApi: require("@/api/ent/dp").default,
      cList: [],
      tableData: [],
      params: {
        DocDateStart: "",
        DocDateEnd: "",
        Source:null,
        PayStatus:null,
        PayType:null,
        DocType:null,
        CustomerName:null,
        DpId:null//所属门店
      },
      DpList:[]
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 4) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2));
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    setSupplier(data) {
      
      console.log("data",data)
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
      console.log("this.params",this.params)
    },
    toSearch() {
      this.api.summaryList(this.params).then(res => {
        this.tableData = []
        this.tableData.push(res.Data)
      })
    }
  },
};
</script>